import type { Action } from "svelte/action";
import { on } from "svelte/events";

/**
 *
 *
 *
 *
 *
 *
 */
export const refireScrollEvent = ((node, host) => ({
  destroy: on(
    node,
    "scroll",
    (event) => {
      /*                                                        */
      host.dispatchEvent(new event.constructor(event.type, event));
    },
    { passive: true, capture: true },
  ),
})) satisfies Action<HTMLElement, HTMLElement>;
